
import { defineComponent, ref, computed, getCurrentInstance } from 'vue';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import Clipboard from '@/plugins/Clipboard';
import { computeHighLightNumberHelper } from '@/heplers';

export default defineComponent({
  name: 'CopyCodeButton',
  components: {
    DocIcon,
  },
  props: {
    codeForCopy: {
      type: String,
      default: '',
    },
    highlight: {
      type: Array as () => string[],
      default: undefined,
    },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const store = proxy.$store;
    const hoverState = ref(false);
    const isCopied = ref(false);

    const isMobile = computed(() => store.state.isMobile);

    function computeLinesForCopy(source: string, highlight: string[]) {
      if (!highlight || !highlight.length) return source;

      const trimmedHighlight = highlight.filter((value) => value !== '');
      if (!trimmedHighlight.length) return source;

      const highlightArrayNumbers: number[] = computeHighLightNumberHelper(trimmedHighlight);

      const linesForCopy = (source.match(/.*\n/g) ?? []).filter((value: string, index: number) =>
        highlightArrayNumbers.includes(index + 1)
      );

      return linesForCopy.join('');
    }

    const preparedCodeForCopy = computed(() =>
      computeLinesForCopy(props.codeForCopy, props.highlight ?? [])
    );

    function copyToClipboard() {
      isCopied.value = true;
      Clipboard.copy(`${preparedCodeForCopy.value}`);
      setTimeout(() => (isCopied.value = false), 2000);
    }

    return {
      isMobile,
      hoverState,
      isCopied,
      preparedCodeForCopy,
      copyToClipboard,
    };
  },
});
